import React from 'react';
import { SharedError } from '../Shared/SharedError';
import { Button, Form, FormGroup, Input } from 'reactstrap';

export class HeaderError extends SharedError {
  constructor(props) {
    super(props);
    this.stripSearchCharacters = this.stripSearchCharacters.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  stripSearchCharacters(term) {
    var result = '';
    var pattern =
      "[\\w\\d\\!\\@\\_\\*\\(\\)\\-\\:\\.\\,\\[\\]\\# \\/\\'\\" +
      String.fromCharCode(201) +
      '\\' +
      String.fromCharCode(232) +
      '\\' +
      String.fromCharCode(233) +
      '\\' +
      String.fromCharCode(234) +
      '\\' +
      String.fromCharCode(244) +
      '\\' +
      String.fromCharCode(216) +
      '\\' +
      String.fromCharCode(248) +
      ']';
    for (var x = 0; x < term.length; x++) {
      var currentChar = term.charAt(x);
      if (currentChar.search(pattern) > -1) result += currentChar;
    }
    return result;
  }
  handleChange(event) {
    var newSearchTerm = this.stripSearchCharacters(event.target.value).split('  ').join(' ');
    var oldSearchTerm = this.state.searchTerm;
    var skipNewSuggestions = false;
    if (newSearchTerm != oldSearchTerm && newSearchTerm.length <= 60) {
      this.setState({ searchTerm: newSearchTerm });
      if (newSearchTerm.trim() == oldSearchTerm) skipNewSuggestions = true;
    }
  }
  handleSubmit(event) {
    if (!this.state.searchTerm || this.state.searchTerm.trim().length < 3) event.preventDefault();
  }
  menuData() {
    //link and display
    var returnArray = [];
    returnArray.push({ display: 'Women', link: 'women' });
    returnArray.push({ display: 'Juniors', link: 'juniors' });
    returnArray.push({ display: 'Shoes', link: 'shoes' });
    returnArray.push({ display: 'Handbags', link: 'handbags' });
    returnArray.push({ display: 'Accessories', link: 'accessories' });
    returnArray.push({ display: 'Lingerie', link: 'lingerie' });
    returnArray.push({ display: 'Beauty', link: 'beauty' });
    returnArray.push({ display: 'Men', link: 'men' });
    returnArray.push({ display: 'Kids', link: 'kids' });
    returnArray.push({ display: 'Home', link: 'home' });
    return returnArray;
  }
  render() {
    if (this.state.error) {
      return (
        <div>
          <section id='header_desktop_wrapper'>
            <div id='my_dillards_bar_wrapper'>
              <div className='container-fluid'>
                <div className='row'>
                  <div className='col-sm-12'>
                    <ul>
                      <li className='hide-when-international'>
                        <a href='/webapp/wcs/stores/servlet/LogonForm?storeId=301&langId=-1&catalogId=301'>
                          Login / My Account
                        </a>
                      </li>
                      <li className='hide-when-international'>
                        <a href='/webapp/wcs/stores/servlet/InterestItemDisplay?storeId=301&catalogId=301&langId=-1'>
                          My Wish List
                        </a>
                      </li>
                      <li>
                        <a href='/webapp/wcs/stores/servlet/OrderItemDisplay?storeId=301&catalogId=301&langId=-1'>
                          Shopping Bag
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className='container-fluid'>
              <header id='header'>
                <div className='row'>
                  <div className='col-sm-3'>
                    <a href='/' manual_cm_sp='Header-_-Logo-_-ImageLink' id='logo-espot'>
                      <svg
                        role='img'
                        aria-labelledby='dillardsLogo'
                        height='53px'
                        width='136px'
                        version='1.1'
                        xmlns='http://www.w3.org/2000/svg'
                        x='0px'
                        y='0px'
                        viewBox='0 0 118.3 44.8'
                        style='enable-background:new 0 0 118.3 44.8;'
                        xmlSpace='preserve'
                      >
                        <title id='dillardsLogo'>Dillard&apos;s The Style of Your Life Homepage</title>
                        <g>
                          <path d='M39.1,29.1h0.1c2.9-0.4,5.9-0.4,8.8,0v-0.5c-2.9-0.4-2.9-0.8-3-3.9V0.4c-0.3-0.7-0.7,0-0.7,0l-1.9,1.3l-2.7,1.2v0.4c2.4,1.4,1.5,1.8,1.7,3.5v17.9c0,3,0.5,3.5-2.3,3.9c-2.7-0.4-2.9-0.8-2.9-3.9V10.9c-0.3-0.5-0.7,0-0.7,0l-1.9,1.3L31,13.4v0.4c2.4,1.4,1.6,1.8,1.7,3.5v7.4c0,3,0.5,3.5-2.4,3.9v0.5C33.2,28.7,36.2,28.7,39.1,29.1z'></path>
                          <path d='M109.4,12.8c0.1-1.6,1.3-2.5,3-2.5c2.3,0,2.8,1.9,3.6,3.7c0,0.1,0.1,0.2,0.2,0.2c0.4,0.3,0.9,0.3,1.3-0.1c1-1,0-3.1-0.3-3.4c-1.3-0.9-2.9-1.4-4.5-1.3c-2.3,0-6.2,2.2-6.2,5.3c0,5.3,8.5,5.7,8.5,10.3c0,0,0,0,0,0c0,1.8-1.4,3.4-3.3,3.4c-2.8,0-3.7-2-4.4-3.7c0,0,0,0,0,0c0-0.4-0.4-0.6-0.7-0.6c-1,0-0.7,2.2-0.1,3.4c0.6,1.2,3,1.8,4.8,1.7v0c4-0.2,7-2.1,7-5.7C118.4,16.3,109.1,17.3,109.4,12.8z'></path>
                          <path d='M2.6,2c0.9,0.3,1.3,1,1.3,3.3v19.3c0,4-3.9,2.6-3.8,4.2c0,0.5,2.3,0.4,2.8,0.3c1-0.4,2.1-0.5,3.2-0.5c1.5,0,4.3,0.6,9.2,0.6c4.4,0,15-1.9,14.8-14.6C30,2.4,19.5-0.1,13,0.1c-2.2,0-4.3,0.3-6.4,0.2C4.8,0,2.9,0.1,1.1,0.4c-0.3,0.1-1,0-1,1C0,1.6,1.7,1.6,2.6,2z M8.2,4.5c0-3,1.5-3.7,4.6-3.7c9.1,0,12.6,10.1,12.4,15C25,22.5,20,28.5,14.5,28.3c-1.6-0.1-6.1-0.8-6.2-4.1V4.5z'></path>
                          <path d='M77.4,24.2v-8.3c0,0-0.4-2.1,2.1-2.3c1.6-0.2,1.5,1.9,4.1,1.6c0.1,0,0.1,0,0.2,0C82.9,17,82.4,19,82.5,21c0,4,3.1,8.1,7.4,8.2c1.8,0,3.7-0.4,5.3-1.2c0.4-0.1,0.3,1.1,0.8,1.1c0.5,0,2.6-0.4,2.6-0.4l3.3,0.4v-0.4c-2.3-1.2-1.9-3.3-1.9-4.9V0.5c0-0.7-0.4-0.2-0.4-0.2L97,1.7l-2.4,1.2l-0.1,0.3c2,1.4,1.6,1.6,1.6,3.3v5.1c-1-0.7-2.1-1.1-3.3-1.2c-2.9-0.1-5.8,1-7.9,3c0-0.3,0-0.7-0.1-1c-0.1-1.1-1.8-1.5-3-1.5c-2.6,0-4.1,2.6-4.5,2.2l-0.2-0.4v-2.5c-0.7-0.7-0.9,0-0.9,0l-1.9,1.3l-2.1,1.1V13c1.3,1.2,1.2,1.3,1.2,3.1v8.2c0,3,0.2,3.7-2.1,4.1c-2.9-0.8-2.1-1.8-2.3-6.2v-5.7c0-3.2,0.1-6-5.2-6c-5.3,0-7.3,4.2-7.3,5.3c0.1,1.5,2.5,0.2,2.9-0.4c0.4-0.7,0.9-3.9,3.6-4c2.4-0.1,2.1,3.5,2,7.8c0,0-5,1.1-7.1,3.3c-0.6,0.6-1.1,1.4-1.4,2.2c-0.5,1.5-0.3,2.5,0.2,3.2c-2.3,1.1-2.7-0.4-2.8-3.2V0.3c-0.4-0.7-0.7,0-0.7,0l-1.9,1.3l-2.7,1.3v0.4c2.4,1.4,1.6,1.8,1.7,3.5v17.9c0,3,0.5,3.5-2.4,3.9V29c2.5-0.3,5-0.3,7.5,0c0.8-0.1,1.6-0.2,2.3-0.4c0.8,0.3,1.7,0.5,2.6,0.4c1.7-0.1,3.3-0.8,4.5-2c0.8,0.7,1.6,2,2.7,2H71c0,0,0.1,0,0.1,0h0.8v-0.1c2.7-0.2,5.4-0.2,8.1,0.1c0-0.2,0-0.4,0-0.6C76.8,28.1,77.4,25.3,77.4,24.2z M92.2,11c1.8,0,4.1,0.5,4.1,5.2l0,9.7c-1,1.9-3.2,1.7-4.7,1.5c-2.9-0.4-5.5-2.4-5.6-8C86,15.4,88.5,11,92.2,11z M65.2,25.8c-0.7,0.8-1.2,1.5-2.3,1.5c-1.8,0-3-1-2.8-2.6c0.3-2.5,4.2-5,5.2-4.3v0C65.2,20.4,65.2,25.8,65.2,25.8z'></path>
                          <path d='M34.2,6.4c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.3-2.3-2.3c-1.2,0-2.3,1-2.3,2.3C32,5.4,33,6.4,34.2,6.4z'></path>
                          <path d='M105.4,7.8c0.3,1.3-0.3,1.7-1.1,2.7v0c2.5-0.6,4.2-3,4-5.6c0-0.2,0-0.4,0-0.5c-0.2-1.2-1.4-2-2.6-1.7c0,0,0,0,0,0c-1.1,0.1-1.8,1.1-1.7,2.1C104.1,6.3,105,6.1,105.4,7.8z'></path>
                          <path d='M0,35.4h0.3l0-0.1c0.5-1.9,1.5-1.9,2-1.9h0.5v7.7H1.7v0.5h4v-0.4H4.4v-7.7h0.5c0.5,0,1.5,0,2,1.9l0,0.1h0.4V33H0V35.4z'></path>
                          <path d='M13.5,37.8c0-1.1-0.7-1.7-1.8-1.7c-0.7,0-1.5,0.3-1.9,0.9v-4.2H7.6v0.4h0.9V41H7.6v0.5h3v-0.4H9.8l0-2.5c0-0.5,0.1-1,0.4-1.4c0.3-0.4,0.8-0.6,1.3-0.7c0.7,0,0.8,0.6,0.8,0.9v3.6h-0.9v0.4h3v-0.4h-0.9V37.8z'></path>
                          <path d='M17.7,36.1c-0.1,0-0.1,0-0.2,0c-1.5,0-2.7,1.3-2.7,2.8c0,0.7,0.2,1.4,0.7,1.9c0.5,0.5,1.1,0.8,1.8,0.8c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.2,0c0.9,0,1.7-0.6,1.9-1.5l0-0.2h-0.4l0,0.1c-0.2,0.8-0.9,1.3-1.7,1.2c-1,0-1.5-0.7-1.5-2.2v-0.4h3.6l0-0.1c0-0.6-0.1-1.2-0.5-1.6C18.8,36.5,18.3,36.2,17.7,36.1z M16.2,38.2c0.1-1.2,0.5-1.7,1.2-1.7c0.5,0,0.9,0.1,0.9,1.2c0,0.2,0,0.3,0,0.5L16.2,38.2z'></path>
                          <path d='M28.3,36.6l-1.5-0.5c-0.8-0.3-1.6-0.6-1.6-1.5c0-0.8,0.7-1.5,1.6-1.5c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c1.1,0,2,0.9,2.1,2l0,0.1h0.4V33h-0.4l0,0.1c-0.1,0.2-0.1,0.2-0.2,0.2s-0.3-0.1-0.5-0.1c-0.3-0.1-0.7-0.3-1.4-0.3c0,0,0,0,0,0c-1.4-0.1-2.6,1-2.7,2.4c0,0.1,0,0.1,0,0.2c0,1.1,0.6,1.8,2,2.1l1.3,0.4c0.8,0.1,1.4,0.8,1.5,1.6c0,0.5-0.1,0.9-0.5,1.2c-0.3,0.3-0.7,0.5-1.2,0.5c-0.1,0-0.2,0-0.3,0c-0.9,0-2.2,0-2.7-2.4l0-0.1h-0.4l0,2.8h0.4l0-0.1c0-0.1,0.1-0.2,0.2-0.2c0.3,0,0.7,0.1,1,0.3c0.5,0.1,1,0.2,1.5,0.2c0.1,0,0.1,0,0.2,0c0.7,0,1.4-0.3,1.9-0.7c0.6-0.5,0.9-1.2,1-2c0-0.1,0-0.1,0-0.2C30.3,37.2,29,36.8,28.3,36.6z'></path>
                          <path d='M35,40.4l-0.4-0.2l0,0.2c0,0.5-0.4,0.9-0.9,0.9c-0.1,0-0.6,0-0.6-0.9v-3.7h1.7v-0.4h-1.7v-1.8L33,34.7c-0.1,0.1-0.3,0.2-0.5,0.1c-0.1,0-0.3,0-0.4-0.1l-0.2-0.1v1.6H31v0.4h0.9v3.6c0,1,0.5,1.4,1.7,1.4c0,0,0.1,0,0.1,0C34.4,41.7,34.9,41.2,35,40.4L35,40.4z'></path>
                          <path d='M41.1,36.3h-2v0.4H40l-1.4,3.2l-1.3-3.2h0.9v-0.4h-3.2v0.4H36l2,4.9l-0.5,1.3c-0.5,1.3-0.8,1.6-1.2,1.6c-0.2,0-0.2,0-0.2-0.1c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.1-0.2,0.1-0.4c0-0.3-0.4-0.5-0.7-0.5c-0.4,0-0.6,0.3-0.7,0.6c0,0,0,0.1,0,0.1c0,0.6,0.5,1,1,1c0,0,0.1,0,0.1,0c0.8,0,1.2-0.6,1.7-1.7c0.1-0.2,0.2-0.4,0.3-0.6c0.2-0.5,0.4-0.9,0.6-1.4l1.9-4.4h0.7V36.3z'></path>
                          <polygon points='43.2,32.9 41.1,32.9 41.1,33.3 42,33.3 42,41.1 41.1,41.1 41.1,41.5 44.1,41.5 44.1,41.1 43.2,41.1 '></polygon>
                          <path d='M47.4,36.1c-0.1,0-0.1,0-0.2,0c-1.5,0-2.7,1.3-2.7,2.8c0,0.7,0.2,1.4,0.7,1.9c0.5,0.5,1.1,0.8,1.8,0.8c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.2,0c0.9,0,1.7-0.6,1.9-1.5l0-0.2H49l0,0.1c-0.2,0.8-0.9,1.3-1.7,1.2c-1.2,0-1.4-1.2-1.4-2.2v-0.4l3.6,0l0-0.1c0-0.6-0.1-1.2-0.5-1.6C48.6,36.5,48,36.2,47.4,36.1z M45.9,38.2c0.1-1.2,0.5-1.7,1.2-1.7c0.5,0,0.9,0.1,0.9,1.2c0,0.2,0,0.3,0,0.5L45.9,38.2z'></path>
                          <path d='M56.9,36.7C56.9,36.7,56.9,36.7,56.9,36.7c-0.2-0.1-0.3-0.2-0.4-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2,0h0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-1.4,0.1-2.6,1.2-2.7,2.7v0c0,0.8,0.4,1.4,1,2c0.5,0.5,1.2,0.7,1.9,0.7c0.1,0,0.1,0,0.2,0c1.4-0.1,2.6-1.2,2.7-2.7c0-0.8-0.4-1.4-1-2C57.1,36.9,57,36.8,56.9,36.7z M55.3,36.6c0.8,0,1.4,0.4,1.4,2.4c0,2.2-0.7,2.4-1.4,2.4s-1.4-0.2-1.4-2.4C53.9,37,54.5,36.6,55.3,36.6z'></path>
                          <path d='M63.3,33.8C63.3,33.7,63.3,33.7,63.3,33.8c0-0.1-0.1-0.2-0.1-0.2c0,0,0,0,0-0.1c-0.2-0.4-0.7-0.7-1.4-0.7h0c-0.7,0.1-1.4,0.4-1.8,1.1c-0.4,0.6-0.6,1.3-0.5,2v0.5h-0.9v0.4h0.9v4.4h-0.9v0.4h3.2v-0.4h-1.1v-4.4h1.4v-0.4h-1.4v-1.5c0-1,0.4-1.6,1-1.6c0.2,0,0.5,0.1,0.5,0.3c0,0.2-0.1,0.2-0.1,0.3C62.1,34,62,34.1,62,34.2c0,0.3,0.4,0.5,0.6,0.5c0,0,0,0,0,0c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0,0,0-0.1,0-0.1C63.4,33.9,63.4,33.9,63.3,33.8z'></path>
                          <polygon points='73.6,33.4 74.8,33.4 74.8,33 72.1,33 72.1,33.4 73.2,33.4 71.2,37.1 69.1,33.4 70.1,33.4 70.1,33 66.3,33 66.3,33.4 67.4,33.4 70,37.9 70,41.1 68.7,41.1 68.7,41.5 72.7,41.5 72.7,41.1 71.4,41.1 71.4,37.6 '></polygon>
                          <path d='M85.7,41.1v-4.8h-2.1v0.4h0.9v2.6c0.1,1-0.6,1.8-1.5,2c-0.3,0-0.5-0.1-0.6-0.3c-0.1-0.2-0.2-0.6-0.2-1v-3.6h-0.1v-0.1H80v0.4h0.9v3.2c0,1,0.4,1.3,0.6,1.5c0.3,0.2,0.7,0.3,1.2,0.3c0,0,0.1,0,0.1,0c0.7,0,1.3-0.4,1.7-0.9v0.7h2.1l0-0.1h0l0,0l0-0.3H85.7z'></path>
                          <path d='M90.8,36.1C90.8,36.1,90.8,36.1,90.8,36.1c-0.6,0-1.1,0.3-1.4,0.8v-0.6h-2.2v0.4h0.9v4.4h-0.9v0.4h3.1v-0.4h-1v-2.5c0-1.3,0.7-1.9,1.1-1.9c0.3,0,0.3,0.1,0.3,0.2c0,0.2,0,0.3-0.1,0.4c0,0.1-0.1,0.2-0.1,0.3c0,0.4,0.4,0.4,0.6,0.4c0.5,0,0.7-0.3,0.7-0.8C91.9,36.6,91.4,36.1,90.8,36.1z'></path>
                          <path d='M102.1,38.8c-0.4,1.5-1.1,2.3-2.3,2.3h-1.9v-7.7h1.3v-0.1h0v-0.2h0V33h-4v0.4h1.3v7.7h-1.3v0.4h7.3v-2.8L102.1,38.8L102.1,38.8z'></path>
                          <polygon points='105.5,36.3 103.4,36.3 103.4,36.7 104.2,36.7 104.2,41.1 103.4,41.1 103.3,41.5 106.4,41.5 106.4,41.1 105.5,41.1 '></polygon>
                          <circle cx='104.8' cy='33.7' r='0.7'></circle>
                          <path d='M109.1,34.8c0-1,0.4-1.6,1-1.6c0.3,0,0.5,0.1,0.5,0.3c0,0.2-0.1,0.2-0.1,0.3c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.3,0.4,0.5,0.6,0.5c0,0,0,0,0,0c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0,0,0-0.1,0-0.1c0-0.5-0.5-1.2-1.6-1.2h0c-0.7,0.1-1.4,0.4-1.8,1.1c-0.4,0.6-0.6,1.3-0.5,2v0.5H107v0.4h0.9v4.4H107l-0.1,0.4h3.2v-0.2h0v-0.2h0v0h-1v-4.4h1.4v-0.4h-1.4V34.8z'></path>
                          <path d='M113.6,36.1c-0.1,0-0.1,0-0.2,0c-1.5,0-2.7,1.3-2.7,2.8c-0.1,1.5,1.1,2.7,2.6,2.8c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.2,0c0.9,0,1.7-0.6,1.9-1.5l0-0.2h-0.4l0,0.1c-0.2,0.8-0.9,1.3-1.7,1.2c-1.2,0-1.4-1.2-1.4-2.2v-0.4l3.6,0l0-0.1c0-0.6-0.1-1.2-0.5-1.6C114.8,36.5,114.2,36.2,113.6,36.1z M114.3,38.2l-2.1,0c0.1-1.2,0.5-1.7,1.2-1.7c0.5,0,0.9,0.1,0.9,1.2C114.3,37.9,114.3,38.1,114.3,38.2z'></path>
                          <circle cx='117.6' cy='40.9' r='0.7'></circle>
                          <path d='M77,36.2L77,36.2c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-1.4,0.1-2.6,1.2-2.7,2.7v0c0,0.8,0.4,1.4,1,2c0.5,0.5,1.2,0.7,1.9,0.7c0.1,0,0.1,0,0.2,0c0.8,0,1.5-0.4,2-1c0.4-0.4,0.6-1,0.7-1.6C79.6,37.4,78.5,36.3,77,36.2z M75.5,38.9c0-1.1,0.2-1.7,0.5-2.1c0.2-0.2,0.5-0.2,0.8-0.2c0.8,0,1.4,0.4,1.4,2.4c0,2.2-0.7,2.4-1.4,2.4c-0.4,0-0.9-0.1-1.1-0.6C75.5,40.2,75.5,39.7,75.5,38.9z'></path>
                        </g>
                      </svg>
                    </a>
                  </div>
                  <div className='col-sm-4'></div>
                  <div className='col-sm-5'>
                    <div id='quick_links'>
                      <div>
                        <ul>
                          <li>
                            <a href='/c/back-in-stock' manual_cm_sp='Header-_-BackInStock-_-TextLink'>
                              Limited Availability
                            </a>
                          </li>
                          <li>
                            <a
                              href='/c/sale-clearance'
                              manual_cm_sp='Header-_-SaleClearance-_-TextLink'
                              className='sale-clearance'
                            >
                              Sale and Clearance
                            </a>
                          </li>
                          <li>
                            <a href='/c/shopbybrand' manual_cm_sp='Header-_-ShopByBrand-_-TextLink'>
                              Shop By Brand
                            </a>
                          </li>
                          <li>
                            <a
                              href='/c/limited-availability'
                              manual_cm_sp='Header-_-LimitedAvailability-_-TextLink'
                              style={{ color: '#267cb5' }}
                            >
                              Limited Availability
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className='search-area'>
                        <Form
                          inline
                          onSubmit={this.handleSubmit}
                          action={`/search-term/${encodeURIComponent(this.state.searchTerm)}`}
                          method='GET'
                        >
                          <FormGroup>
                            <Input
                              type='text'
                              value={this.state.searchTerm || ''}
                              onChange={this.handleChange}
                              className='form-control search-input search-enabled'
                            />
                            <Button
                              data-twist='search-button'
                              className='btn btn-search'
                              title='Search Dillards.com'
                              type='submit'
                            ></Button>
                            {typeof window != 'undefined' && window.DILLARDS.country != 'US' ? (
                              <Input type='hidden' name='facet' value='dil_shipinternational:Y' />
                            ) : (
                              ''
                            )}
                          </FormGroup>
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </header>
            </div>
          </section>
          <section id='menu_wrapper'>
            <div
              className={`${this.props.passedAppFunctions.siteFormat == 'tablet' ? 'container' : 'container-fluid'}`}
            >
              <nav id='main_nav'>
                <ul className='menu'>
                  {this.menuData().map((menu, index) => (
                    <li key={index}>
                      <a href={`/c/${menu.link}`} id={`topcat_${menu.display}`} data-supername={menu.display}>
                        {menu.display}
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          </section>
          {this.renderHiddenError('Header')}
        </div>
      );
    } else {
      return this.props.children;
    }
  }
}

export default HeaderError;
